import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import ReactToPrint from 'react-to-print'
import { taskOperationsService } from '../../../_services/taskOperations.service'
import moment from 'moment-jalaali'
import Loading from '../../Shared/Loading'
import MeasurementTypeDoubleBox from '../../Shared/MeasurementTypeDoubleBox'

import { MdPrint } from 'react-icons/md'
import { AiOutlineLoading } from 'react-icons/ai'
import { DateTime } from 'luxon'
// import { el } from 'date-fns/locale'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})

const PrintMultiTasks = props => {
  const [loading, setLoading] = useState(false)
  const [showDialog, setShowDialog] = useState(false)
  const [dto, setDto] = useState(props.dto)
  const [data, setData] = useState(undefined)

  const printSection = useRef()

  useEffect(() => {
    if (props.show && props.dto) {
      setDto(props.dto)
      getData()
    } else {
      setDto(undefined)
      setData(undefined)
    }
    setShowDialog(props.show)
  }, [props.show])

  const getData = () => {
    setLoading(true)
    if (props.dto) {
      taskOperationsService
        .GetByIdHistoryMultiTasks(JSON.stringify(props.dto))
        .then(ress => {
          let res = ress.data

          // res["lastDescription"] = res.description;
          // res["description"] = '';

          // if (res.items) {

          //   let outputs = []
          //   res.items.forEach(item => {
          //     item["extraQuantity"] = 0;
          //     item["subExtraQuantity"] = 0;
          //     item["firstQuantity"] = item.quantity;
          //     if (item.taskOperationProductType === 1) {
          //       outputs.push(item)
          //     }
          //   });

          //   res["items"] = res.items.filter(el => parseInt(el.taskOperationProductType, 0) === 0);
          //   res["outputs"] = outputs;

          // }

          console.log(res)
          setData(res)
          setLoading(false)
        })
        .catch(error => {
          // console.log(error);
          setLoading(false)
        })
    }
  }

  const handleCloseDialog = () => {
    setShowDialog(false)

    props.onClose()
  }

  const handlePrint = () => {
    setLoading(false)

    props.onClose()
  }

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        className="message-dialog"
        open={props.show}
        TransitionComponent={Transition}
        onClose={() => handleCloseDialog()}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description">
        <DialogContent className="inquiry-result-container">
          <ReactToPrint
            onAfterPrint={() => handlePrint()}
            trigger={() => (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <a
                  className="btn btn-block btn-primary"
                  onClick={() => setLoading(true)}>
                  {loading ? (
                    <AiOutlineLoading
                      className="mdi-spin"
                      size="32px"
                      style={{ marginLeft: 10 }}
                    />
                  ) : (
                    <MdPrint
                      size="32px"
                      style={{ verticalAlign: 'middle', marginLeft: 10 }}
                    />
                  )}
                  چاپ
                </a>
              </div>
            )}
            content={() => printSection.current}
          />
          <div ref={printSection} className="print-container">
            {data && data.length > 0 ? (
              dto.compactPrint ? (
                <React.Fragment>
                  <div className="print">
                    <page className="A4">
                      <section class="sheet padding-10mm">
                        {data.map(item => (
                          <React.Fragment key={item.id}>
                            <div className="page-break" />
                            <div className="row">
                              <table className="table4col">
                                <thead>
                                  <tr>
                                    <th>
                                      <strong>#{item.task.taskCode}</strong>
                                    </th>
                                    <th
                                      style={{
                                        borderLeft: '1px solid #000',
                                        borderRight: '1px solid #000'
                                      }}>
                                      {item.product.brand.name}
                                    </th>
                                    <th
                                      style={{
                                        borderLeft: '1px solid #000',
                                        borderRight: '1px solid #000'
                                      }}>
                                      {item.product.name}
                                    </th>
                                    <th>{item.unit && item.unit.name}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {item.productItems &&
                                    item.productItems.map((item, index) =>
                                      item.product.category.id !== 6 &&
                                      item.taskOperationProductType === 0 ? (
                                        <tr key={'input-product-' + index}>
                                          <td>
                                            <strong>
                                              {item.product.category.name}
                                            </strong>
                                          </td>
                                          <td>{item.product.brand.name}</td>
                                          <td>{item.product.name}</td>
                                          <td>
                                            {item.product && (
                                              <MeasurementTypeDoubleBox
                                                product={item.product}
                                                value={item.quantity}
                                                onlySub={
                                                  item.product
                                                    .subMeasurementType !== null
                                                    ? true
                                                    : false
                                                }
                                              />
                                            )}
                                          </td>
                                        </tr>
                                      ) : (
                                        ''
                                      )
                                    )}
                                </tbody>
                              </table>
                            </div>
                            <div className="page-break" />
                          </React.Fragment>
                        ))}
                        <div
                          style={{
                            display: 'flex',
                            width: '100%',
                            textAlign: 'right',
                            justifyContent: 'flex-start'
                          }}>
                          <div
                            className="date"
                            style={{ display: 'flex', alignItems: 'center' }}>
                            <div
                              className="date-title"
                              style={{ marginLeft: 5 }}>
                              <strong>تاریخ پرینت:</strong>
                            </div>
                            <div className="date-date">
                              {moment(new moment()).format('jYYYY/jM/jD')}
                            </div>
                          </div>
                          <div
                            className="date"
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              marginRight: 20
                            }}>
                            <div
                              className="date-title"
                              style={{ marginLeft: 5 }}>
                              <strong>ساعت پرینت:</strong>
                            </div>
                            <div className="date-date">
                              {moment(new moment()).format('H:mm')}
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              marginRight: 20
                            }}>
                            <div style={{ marginLeft: 5 }}>
                              <strong>نام کاربر:</strong>
                            </div>
                            <div>{props.user.fullName}</div>
                          </div>
                        </div>
                      </section>
                    </page>
                  </div>
                </React.Fragment>
              ) : (
                data.map(item => (
                  <React.Fragment key={item.id}>
                    <div className="page-break" />
                    <div className="print">
                      <page className="A4">
                        <section class="sheet padding-10mm">
                          <div className="row">
                            <table className="table3col ">
                              <thead>
                                <tr>
                                  <th colSpan="3">اطلاعات کالا جهت تولید</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td rowspan="2">
                                    <div
                                      style={{
                                        fontSize: 40,
                                        fontWeight: 'bold',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: '100%'
                                      }}>
                                      #{item.task.taskCode}
                                    </div>
                                  </td>
                                  <td>
                                    <strong>برند</strong>
                                  </td>
                                  <td>{item.product.brand.name}</td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      borderRight: '1px solid #000',
                                      borderLeft: '1px solid #000'
                                    }}>
                                    <strong>نام کالا جهت تولید</strong>
                                  </td>
                                  <td>{item.product.name}</td>
                                </tr>
                                <tr>
                                  <td>{item.unit && item.unit.name}</td>
                                  <td>
                                    <strong>کد کالا</strong>
                                  </td>
                                  <td>{item.product.extraCode}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div className="row">
                            <table className="table4col">
                              <thead>
                                <tr>
                                  <th colSpan="4">
                                    مشخصات مواد اولیه مورد نیاز
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>دسته بندی</strong>
                                  </td>
                                  <td>
                                    <strong>برند</strong>
                                  </td>
                                  <td>
                                    <strong>نام کالا</strong>
                                  </td>
                                  <td style={{ width: 120 }}>
                                    <strong>مقدار</strong>
                                  </td>
                                </tr>
                                {item.productItems &&
                                  item.productItems.map((item, index) =>
                                    item.product.category.id !== 6 &&
                                    item.taskOperationProductType === 0 ? (
                                      <tr key={'input-product-' + index}>
                                        <td>
                                          <strong>
                                            {item.product.category.name}
                                          </strong>
                                        </td>
                                        <td>{item.product.brand.name}</td>
                                        <td>{item.product.name}</td>
                                        <td>
                                          {item.product && (
                                            <MeasurementTypeDoubleBox
                                              product={item.product}
                                              value={item.quantity}
                                              onlySub={
                                                item.product
                                                  .subMeasurementType !== null
                                                  ? true
                                                  : false
                                              }
                                            />
                                          )}
                                        </td>
                                      </tr>
                                    ) : (
                                      ''
                                    )
                                  )}
                              </tbody>
                            </table>
                          </div>

                          <div className="row">
                            <table className="table4col">
                              <thead>
                                <tr>
                                  <th>توضیحات تکمیلی سرشیفت</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td
                                    className="big-cell"
                                    style={{ height: 150 }}
                                  />
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              width: '100%',
                              textAlign: 'right',
                              justifyContent: 'flex-start'
                            }}>
                            <div
                              className="date"
                              style={{ display: 'flex', alignItems: 'center' }}>
                              <div
                                className="date-title"
                                style={{ marginLeft: 5 }}>
                                <strong>تاریخ پرینت:</strong>
                              </div>
                              <div className="date-date">
                                {moment(item.printedAt, 'YYYY/M/D H:m').format(
                                  'jYYYY/jM/jD'
                                )}
                              </div>
                            </div>
                            <div
                              className="date"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginRight: 20
                              }}>
                              <div
                                className="date-title"
                                style={{ marginLeft: 5 }}>
                                <strong>ساعت پرینت:</strong>
                              </div>
                              <div className="date-date">
                                {moment(item.printedAt, 'YYYY/M/D H:m').format(
                                  'H:mm'
                                )}
                              </div>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginRight: 20
                              }}>
                              <div style={{ marginLeft: 5 }}>
                                <strong>نام کاربر:</strong>
                              </div>
                              <div>{props.user.fullName}</div>
                            </div>
                          </div>
                        </section>
                      </page>{' '}
                    </div>
                  </React.Fragment>
                ))
              )
            ) : (
              ''
            )}
          </div>
          {loading ? <Loading /> : ''}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  const { authentication } = state
  const { user } = authentication
  return {
    user
  }
}

const connectedPrint = connect(mapStateToProps)(PrintMultiTasks)
export { connectedPrint as PrintMultiTasks }
